export const invitationTokenConstants = {
  BASE_PATH: 'v1/invitation_tokens',
};
